/**
 * Formata número como percentual com 1 casa decimal e vírgula.
 * Ex: 45.678 → "45,7"
 */
export const formatPct = (value) => {
    return Number(value).toFixed(1).replace('.', ',');
};

/**
 * Variante do modal "Padrão do Imóvel" (PadraoInfoModal) para o título da tabela, ou
 * `null` quando não há explicação de faixas — é o caso do HORIZONTAL puro, que só reúne
 * loteamentos. Mesma regra do mapa Google (TablePadroes/TablePrecosPadroes/TableVGV).
 */
export const padraoInfoVariant = (title) => {
    if (title === 'VERTICAL') return 'vertical';
    if (title === 'COMERCIAL') return 'comercial';
    if (title === 'HORIZONTAL - CONDOMÍNIO DE CASAS/SOBRADOS') return 'casas';

    return null;
};
